import React from 'react';
import ReactDOM from 'react-dom/client';
import {  createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
// import App from './App';
import Root from './Root/Root.jsx';
import {  Company, Contact, Services, Solutions, Work,LandingPage,IndustriesPage, Quotation, TandC, Faq, Products, CaseStudiesPage } from "./Pages/index.js";
import ErrorPage from './Pages/Error/Error.js';
import Layout from './Pages/Industry/Layout/Layout.js';
import ThankYouPage from './Pages/LandingPage/ThankYou.js';
import { Toaster } from 'react-hot-toast';
import CaseStudyDetail from './Pages/CaseStudy/CaseDetails.js';
import Category from './Pages/Services/DetailsPages/Category.js'
import SubCategory from './Pages/Services/DetailsPages/SubCategory.js'
import ProjectDetails from './Pages/Work/ProjectDetails.js';
import Home from './Components/Home/Home.js';
// import LandingPageLead from './Pages/LandingPageLead/LandingPageLead.js';



const Routes= createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    children: [
      {
        path: '/',
        element: <Home/>,
      },
      // {
      //   path: '/about',
      //   element:<About/>,
      // },
      {
        path: '/contact',
        element:<Contact/>,
      },
      {
        path:'/about',
        element:<Company/>,
      },
      {
        path: '/solutions',
        element:<Solutions/>,
      },
      {
        path:'/industries/:slug',
        element:<Layout/>,
      },
      {
        path: '/services',
        element:<Services/>,
      },
      {
        path:'/services/:slug',
        element:<Category/>
      },
      {
        path:'/services/:serviceSlug/:subSlug',
        element:<SubCategory/>
      },
      {
        path: '/work',
        element:<Work/>,
      },
      {
        path: '/work/:slug',
        element:<ProjectDetails/>
      },
      {
        path: '/industries',
        element:<IndustriesPage/>,
      },
      {
        path:'/quotation',
        element:<Quotation/>
      },
     {
      path:'/case-studies',
      element:<CaseStudiesPage/>
     },
     {
      path:'/case-studies/:slug',
      element:<CaseStudyDetail/>
     },
      {
        path:'/terms-and-conditions',
        element:<TandC/>        
      },
      {
        path:'faqs',
        element:<Faq/>
      },
      {
        path:'products',
        element:<Products/>
      }   
    ]
    
    
  },
  {
    path: '*',
    element: <ErrorPage/>
  },
  { 
    path: '/lp/full-stack-webdevelopment-and-digital-marketing',
    element: <LandingPage />,
  },
  // {
  //   path:'/lp/leads-for-sale',
  //   element:<LandingPageLead/>
  // },
  {
    path: '/lp/full-stack-webdevelopment-and-digital-marketing/thank-you',
    element: <ThankYouPage />,
  }
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <RouterProvider router={Routes}>
<Toaster
  position="top-center"
  reverseOrder={false}
/>
    </RouterProvider>

);



